/** @import Status from '@/classes/scoped-list/Status' */

/**
 * Clase para representar un fichero subido
 */
export default class FileItem {
  /** @type {String} */ name
  /** @type {Number} */ percentage
  /** @type {File} */ raw
  /** @type {Number} */ size
  /** @type {String} */ status
  /** @type {Number} */ uid
  /** @type {Boolean} */ loading
  /** @type {String} */ tooltip
  /** @type {Status} */ estado
  /** @type {Array<FileItem>} */ files
}
